import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Tag,
  TagLabel,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { SearchIcon } from "@chakra-ui/icons";
import EditTask from "../../components/jobProfile/editDepartment";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";

import { deleteApi } from "common/services/api";

import { toast } from "react-toastify";

import viewIcon from "common/assets/img/viewIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import { constant } from "common/constant";
import DateFormatter from "common/utils/dateFormater";
import { globalStyles } from "common/theme/styles";
import CustomStatus from "common/components/status/CustomStatus";
import { InterviewData } from "services/Recruit/data/interviewData";
import Rating from "services/Recruit/components/Rating/Rating";
import { candidateColums } from "services/Recruit/data/candidate";
import StatusProgress from "services/Recruit/components/StatusProgress/StatusProgress";
import { recruitConstant } from "services/Recruit/constant";
import { panelColumns } from "services/Recruit/data/panel.Data";
import AvailabilityDropdown from "services/Recruit/components/AvailabilityDropdown";
import SkillsSection from "services/Recruit/components/SkillsSection;";
import StatusOfferLetter from "services/Recruit/components/StatusOfferLetter/StatusOfferLtter";
import { timeSlots } from "services/Recruit/data/panel.Data";
import CustomDropdown from "services/Recruit/components/CustomDropdown/CustomDropdown";
import { totalExperienceOptions } from "services/Recruit/data/panel.Data";
import deleteIcon from "common/assets/img/deleteIcon.png";
import CustomStatusDropdown from "services/Recruit/components/CustomStatusDropdown/CustomStatusDropdown";
import { customDropDownData } from "services/Recruit/data/recruitData";
import { accessModuleTitles } from "common/constant";
import { putApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { deleteManyApi } from "common/services/api";
import { interviewAvailabilityOptions } from "services/Recruit/data/dropdownData";
import MultiSelectDropdown from "services/Recruit/components/multipleSelectDropdown/multipleSelectDropdown";

const Panel = ({
  availability,
  experience,
  onAvailabilityChange,
  onExperienceChange,
}) => {
  const title = recruitConstant.panel;
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [edit, setEdit] = useState(false);
  const [eventView, setEventView] = useState(false);
  const [id, setId] = useState("");
  const [selectedId, setSelectedId] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [deleteMany, setDeleteMany] = useState(false);
  const [isImportLead, setIsImportLead] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const colors = globalStyles.colors;
  const [tableData, setTableData] = useState(panelColumns);
  const [selectedTime, setSelectedTime] = useState("");
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const [deleteModel, setDelete] = useState(false);

  const [permission, leadAccess, contactAccess] = HasAccess([
    accessModuleTitles.Panels,
  ]);
  const navigate = useNavigate();

  const location = useLocation();
  const state = location.state;

  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.currentPage
      ? paginationState.currentPage
      : 1;
  });

  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.pageSize
      ? paginationState.pageSize
      : 10;
  });
  const [sortColumn, setSortColumn] = useState(null); // Track the sorted column
  const [sortOrder, setSortOrder] = useState("");
  const [searchbox, setSearchbox] = useState(null);
  const [finalSearchedData, setFinalSearchedData] = useState([]);
  const [metadata, setMetadata] = useState({});

  const EditData = async (value, id) => {
    console.log("status value", value);
    try {
      let response = await putApi(
        `${API_PATHS.RECRUITMENT_INDIVIDUAL_PANEL}${id}`,
        { interviewAvailability: value }
      );
      if (response.status === 200) {
        toast.success("Panel updated successfully");
        navigate("/recruitment/panels");
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    }
  };

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    cell: ({ row }) => (
      <Text fontSize="md" fontWeight="900" textAlign={"center"}>
        <Box className="actionCellContainer">
          {/* {permission?.update && (
                        <Image
                            onClick={() =>
                                navigate(`/recruitment/panel-create/${row?.values?.id}`)
                            }
                            src={viewIcon}
                            h={"20px"}
                            w={"20px"}
                        />
                    )} */}
          {permission?.update && (
            <Image
              onClick={() =>
                navigate(`/recruitment/panel-create/${row?.values?._id}`)
              }
              src={editIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
          {permission?.delete && (
            <Image
              onClick={() => {
                setDelete(true);
                setSelectedValues([row?.values?._id]);
                setMenuSelectedDeleteItem([row?.values?._id]);
              }}
              src={deleteIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
        </Box>
      </Text>
    ),
  };
  const tableColumns = [
    {
      Header: "#",
      accessor: "_id",
      isSortable: false,
      width: 5,
    },

    {
      Header: recruitConstant.name,
      accessor: "panelName",
      cell: (cell) => (
        <Text cursor={"pointer"} onClick={() => navigate(`/recruitment/panel-create/${cell?.row?.values?._id}`)}>{(cell?.value?.firstName || cell?.value?.lastName) ? cell?.value?.firstName + " " + cell?.value?.lastName : '-'}</Text>
      ),
    },

    {
      Header: recruitConstant.skills,
      accessor: "skills",
      cell: (props) => {
        console.log("Full props object:", props);

        // Handle different possible prop structures
        let cellValue;
        if (props?.cell?.value !== undefined) {
          cellValue = props.cell.value;
        } else if (props?.value !== undefined) {
          cellValue = props.value;
        } else if (props?.row?.original?.skills !== undefined) {
          cellValue = props.row.original.skills;
        } else if (props?.original?.skills !== undefined) {
          cellValue = props.original.skills;
        } else {
          cellValue = null;
        }

        console.log("Cell value:", cellValue);
        console.log("Cell value type:", typeof cellValue);

        let skills = [];

        // Handle different data formats
        if (Array.isArray(cellValue)) {
          skills = cellValue;
        } else if (typeof cellValue === "string" && cellValue) {
          // If it's a string, try to parse it or split it
          try {
            skills = JSON.parse(cellValue);
          } catch {
            // If parsing fails, split by comma or use as single skill
            skills = cellValue.includes(",")
              ? cellValue.split(",").map((s) => s.trim())
              : [cellValue];
          }
        } else {
          skills = [];
        }

        console.log("Processed skills:", skills);
        const visibleSkills = skills.slice(0, 2);
        const remainingSkills = skills.slice(2);

        return (
          <Flex gap={2} wrap="wrap">
            {visibleSkills.map((skill, idx) => {
              const formattedSkill = skill.trim().charAt(0).toUpperCase() + skill.trim().slice(1);
              return (
                <Tag
                  key={idx}
                  size="sm"
                  px={3} py={2} borderRadius="md" bg="gray.300"
                >
                  {formattedSkill}
                </Tag>
              );
            })}

            {remainingSkills.length > 0 && (
              <Popover placement="right-start">
                <PopoverTrigger>
                  <Tag
                    size="sm"
                    px={3}
                    py={1}
                    bg="gray.300"
                    borderRadius="full"
                    cursor="pointer"
                  >
                    +{remainingSkills.length}
                  </Tag>
                </PopoverTrigger>
                <PopoverContent w="200px" maxH="300px" overflowY="auto">
                  <PopoverArrow />
                  <PopoverBody>
                    <Flex direction="column" gap={2}>
                      {remainingSkills.map((skill, idx) => {
                        const formattedSkill = skill.trim().charAt(0).toUpperCase() + skill.trim().slice(1);
                        return (
                          <Tag
                            key={idx}
                            px={3}
                            py={2}
                            borderRadius="md"
                            bg="gray.300"
                          >
                            {formattedSkill}
                          </Tag>
                        );
                      })}
                    </Flex>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            )}

            {skills.length === 0 && (
              <Text fontSize="sm" color="gray.500">
                No skills
              </Text>
            )}
          </Flex>
        );
      },
    },

    {
      Header: recruitConstant.totalExprience,
      accessor: "totalExperienceRange",
      type: "text",
      //   formikType: "",
      //   cell: (cell) => (
      //     <div>
      //        <CustomDropdown options={totalExperienceOptions} value={experience} onChange={onExperienceChange} />

      //     </div>
      //   ),
    },
    {
      Header: recruitConstant.availability,
      accessor: "interviewAvailability",
      type: "text",
      formikType: "",
      // cell: (cell) => {
      //     console.log("initial status",cell?.row?.original?.interviewAvailability)
      //     return(
      //     <div>
      //         <CustomDropdown options={interviewAvailabilityOptions} value={cell?.row?.original?.interviewAvailability} onChange={(newStatus) =>
      //             EditData(newStatus, cell?.row?.original?._id)
      //         } />
      //     </div>
      // )}

      cell: (cell) => {
        const initialValues = cell?.row?.original?.interviewAvailability || [];

        return (
          <MultiSelectDropdown
            disable={!permission?.update}
            options={interviewAvailabilityOptions}
            value={initialValues}
            onChange={(newStatus) =>
              EditData(newStatus, cell?.row?.original?._id)
            }
          />
        );
      },
    },

    ...(permission?.update || permission?.delete
      ? [actionHeader]
      : []),
  ];

  const fetchData = async (
    page = currentPage,
    limit = pageSize,
    sortKey = sortColumn,
    order = sortOrder,
    searchTerm = "",
    fetchAllData = false,
    status = ""
  ) => {
    setIsLoading(true);

    let endpoint = `api/recruitment/panel/?page=${page}&limit=${limit}`;

    if (fetchAllData) {
      endpoint = `api/recruitment/panel/?allData=true`;
    }

    if (sortKey) {
      const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
      endpoint += `&sort=${sortParam}`;
    }

    if (searchTerm) {
      endpoint += `&search=${encodeURIComponent(searchTerm)}`;
    }

    if (status) {
      endpoint += `&status=${encodeURIComponent(status)}`;
    }

    try {
      const result = await getApi(endpoint);
      if (fetchAllData) {
        setFinalSearchedData(result?.data?.data);
      } else {
        setData(result?.data?.data || []);
        setMetadata(result?.data?.metadata);
      }
    } catch (e) {
      toast.error(recruitConstant.errorMsg);
      console.error("Error fetching job openings:", e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (term) => {
    const pageToFetch = term?.trim() === "" ? currentPage : 1;
    if (term?.trim() !== "" && currentPage !== 1) {
      setCurrentPage(1);
    }
    fetchData(pageToFetch, pageSize, sortColumn, sortOrder, term, false);
  };

  const handleSortChange = (accessorKey) => {
    let newSortOrder = "asc";

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortColumn(accessorKey);
    setSortOrder(newSortOrder);

    fetchData(currentPage, pageSize, accessorKey, newSortOrder);
  };

  // "api/recruitment/application/deleteMany"

  const handleDeletePanel = async (ids) => {
    try {
      setDelete(false);
      let response = await deleteManyApi(
        "api/recruitment/panel/deleteMany",
        ids
      );
      if (response.status === 200) {
        setSelectedValues([]);
        fetchData(currentPage, pageSize);
        toast.success(
          `${menuSelectedDeleteItem.length > 0
            ? constant.panel
            : selectedValues && selectedValues.length > 1
              ? `${constant.panel}s`
              : constant.panel
          } ${constant.deletedSuccessfully}`
        );
        setAction((pre) => !pre);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setMenuSelectedDeleteItem([]);
    }
  };

  const [columns, setColumns] = useState([...tableColumns]);
  const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);
  const dataColumn = tableColumns?.filter((item) =>
    selectedColumns?.find((colum) => colum?.Header === item.Header)
  );
  useEffect(() => {
    fetchData(currentPage, pageSize, sortColumn, sortOrder, searchbox, false);
  }, []);

  function closeDeleteModal() {
    setMenuSelectedDeleteItem([]);
    setDelete(false);
  }

  const onLinkClick = (id) => {
    console.log(id);
    return `/recruitment/panel-create/${id}`;
  };

  return (
    <div>
      <CommonCheckTable
        title={title}
        showInlineTitle={true}
        isLoading={isLoading}
        columnData={columns}
        dataColumn={dataColumn}
        allData={data}
        tableData={data}
        // searchDisplay={displaySearchData}
        setSearchDisplay={setDisplaySearchData}
        // searchedDataOut={searchedData}
        // setSearchedDataOut={setSearchedData}
        tableCustomFields={[]}
        access={permission}
        action={action}
        onLinkClick={onLinkClick}
        setAction={setAction}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onclose}
        // state={state}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDelete}
        fetchData={fetchData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        // AdvanceSearch={
        //     <Button
        //         variant="outline"
        //         className="advance-search-button"
        //         colorScheme="brand"
        //         leftIcon={<SearchIcon />}
        //         mt={{ sm: "5px", md: "0" }}
        //         size="sm"
        //         onClick={() => setAdvanceSearch(true)}
        //     >
        //         {recruitConstant.advanceSearch}
        //     </Button>
        // }
        getTagValuesOutSide={getTagValuesOutSide}
        searchboxOutside={searchboxOutside}
        setGetTagValuesOutside={setGetTagValuesOutside}
        setSearchboxOutside={setSearchboxOutside}
        sortOrder={sortOrder}
        searchbox={searchbox}
        setSearchbox={setSearchbox}
        finalSearchedData={finalSearchedData}
        setFinalSearchedData={setFinalSearchedData}
        metadata={metadata}
        handleSortChange={handleSortChange}
        handleSearchChange={handleSearchChange}
        isDynamic={true}
      />

      <CommonDeleteModel
        isOpen={deleteModel}
        onClose={() => closeDeleteModal()}
        type={
          menuSelectedDeleteItem.length > 0
            ? constant.panel
            : selectedValues && selectedValues.length > 1
              ? `${constant.panel}s`
              : constant.panel
        }
        handleDeleteData={handleDeletePanel}
        ids={selectedValues}
        onCancel={() => setSelectedValues([])} // Clear selections when modal is closed without deletion
      />
    </div>
  );
};

export default Panel;
